import {Tabs} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo} from 'react'
import {useParams} from 'react-router-dom'
import {gConfigs, gPaths} from 'views/AppLocals/configs'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import useNavRouteAction from 'views/AppLocals/hooks/useNavRouteAction'
import {NavRoutes} from 'views/AppLocals/hooks/useNavRoutes'
import {notEmpty, NullAsDefault} from 'views/Shared'
import EventContext from '../EventContext'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const EventNav = ({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {isSm, isLg} = useContext(LayoutContext) || {}
    const params = useParams()

    const history = useHistory()

    const id = _.get(params, 'id')

    const rootPath = gPaths.event

    const {
        event,
        routeEntities = [],
        getDefaultAction = NullAsDefault,
    } = useContext(EventContext)

    const defaultAction = getDefaultAction(rootPath)

    const visibleRoutes = useMemo(
        () =>
            routeEntities.filter(({isInvisible = NullAsDefault}) =>
                !isInvisible({item: event, isLg})
            ),
        [event, routeEntities, isLg]
    )

    const isValidVisibleRoute = useCallback(
        (route) => visibleRoutes.some(({path}) => path === route),
        [visibleRoutes]
    )

    const {currentAction} = useNavRouteAction({
        anchor: id,
        defaultAction,
        isAction: isValidVisibleRoute,
    })

    const pathTransform = useCallback(
        (path, segment) =>
            [
                _.isEmpty(id)
                    ? path
                    : mapPathParam(path, {
                        id,
                    }),
                segment,
            ]
                .filter(notEmpty)
                .join('/'),
        [id]
    )

    const tabItems = useMemo(
        () =>
            visibleRoutes
                .map(({ path, breadcrumbName = NullAsDefault }) => ({
                    key: path,
                    label: breadcrumbName(t),
                    children: (
                        <NavRoutes
                            rootPath={rootPath}
                            routes={visibleRoutes}
                            transform={pathTransform}
                            defaultAction={defaultAction}
                        />
                    ),
                })),
        [rootPath, defaultAction, visibleRoutes, pathTransform, t]
    );

    return (
        <Wrapper
            id="content"
            className="space-y-3 rounded-b-xl">
            <Tabs
                id="tab_content"
                destroyOnHidden={true}
                tabBarStyle={gConfigs.styles.tabBar}
                onChange={(activeKey) => {
                    // setTimeout(() => {
                    //     scrollToSection("tab_content")
                    // }, 1000);
                    history.push({
                        pathname: pathTransform(rootPath, activeKey),
                    });
                }}
                activeKey={currentAction}
                items={tabItems}
            />
        </Wrapper>
    )
}

export default EventNav
